<template>
  <div>
    <b-loading :active.sync="loading"/>
    <div class="w-full flex justify-between items-start">
      <Lynx-Title text="Satisfação dos Clientes"/>

      <div class="flex flex-row-reverse items-end mb-4">
        <b-button
          class="is-primary ml-4"
          icon-right="refresh"
          @click.native="fetchSatisfacao"
        >
          Atualizar Lista
        </b-button>
        <b-button
        text=""
        class=" is-primary "
        icon-size="3"
        @click.native="exportRelatorio('relatorio')"
      >
      Relatorio
        </b-button>
 

    </div>
    

    </div>
      <div class="flex flex-col">
      <!-- <div class="w-full flex">
        <label class="flex flex-col w-1/2 pb-6 pr-3">
          <Lynx-Label label="Data Inicial" />
          <b-datepicker
            v-model="form_pes.data_inicio"
            placeholder="Selecione uma data"
            :date-formatter="
              (date) => moment(date, 'YYYY/MM/DD').format('DD/MM/YYYY')
            "
            :date-parser="(date) => new Date(date)"
            :month-names="monthNames"
            :day-names="dayNames"
            :years-range="[-20, 10]"
          />
        </label>
        <label class="flex flex-col w-1/2 pb-6 pr-3">
          <Lynx-Label label="Data Final" />
          <b-datepicker
            v-model="form_pes.data_fim"
            placeholder="Selecione uma data"
            :date-formatter="
              (date) => moment(date, 'YYYY/MM/DD').format('DD/MM/YYYY')
            "
            :date-parser="(date) => new Date(date)"
            :month-names="monthNames"
            :day-names="dayNames"
            :years-range="[-20, 10]"
          />
        </label>
      
        <label class="flex flex-col w-1/2 pb-6 pr-3">
           
          <Lynx-Button
            text="Relatorio Satisfacao"
            class="mb-4"
            style="margin-top:32px;"
            @click.native="gerarRelatorio()"
            size="small"
            icon-size="3"
          />
        </label>
      </div> -->
    </div>
    <div class="flex flex-col">
      <div class="w-full flex">
        <label class="flex flex-col w-1/2 pb-6 pr-3">
          <Lynx-Label label="Data Inicial" />
          <b-datepicker
            v-model="form_pes.data_inicio"
            placeholder="Selecione uma data"
            :date-formatter="
              (date) => moment(date, 'YYYY/MM/DD').format('DD/MM/YYYY')
            "
            :date-parser="(date) => new Date(date)"
            :month-names="monthNames"
            :day-names="dayNames"
            :years-range="[-20, 10]"
            @input="filtersItems"
          />
        </label>
        <label class="flex flex-col w-1/2 pb-6 pr-3">
          <Lynx-Label label="Data Final" />
          <b-datepicker
            v-model="form_pes.data_fim"
            placeholder="Selecione uma data"
            :date-formatter="
              (date) => moment(date, 'YYYY/MM/DD').format('DD/MM/YYYY')
            "
            :date-parser="(date) => new Date(date)"
            :month-names="monthNames"
            :day-names="dayNames"
            :years-range="[-20, 10]"
            @input="filtersItems"

          />
        </label>
      
        <!-- <label class="flex flex-col w-1/2 pb-6 pr-3">
           
          <Lynx-Button
            text="Relatorio Indicações"
            class="mb-4"
            style="margin-top:32px;"
            @click.native="gerarRelatorio()"
            size="small"
            icon-size="3"
          />
        </label> -->
      </div>
    </div>

    <b-table :columns="columns" :data="satisfacao_filtro" paginated per-page="10">
      <template slot-scope="props" v-if="props.row.cliente != null">
        <b-table-column  field="id" v-text="props.row.id"/>
        <b-table-column   field="cliente->id">
          {{ props.row.cliente.id }}
        </b-table-column>
        
        <b-table-column  field="cliente->nome_completo">
          {{ props.row.cliente.nome_completo }}
        </b-table-column>
        <b-table-column  field="created_at">
            {{ props.row.created_at  | formatEnToBr}}
        </b-table-column>
        <b-table-column  field="status">

          <img v-if="props.row.satisfacao < 5" width="20px" src=" https://i.im.ge/2023/03/31/ID7qma.5000000.png" alt="">
          <img  v-if="props.row.satisfacao == 5" width="20px" src=" https://i.im.ge/2023/03/31/ID7sWJ.50000005.png" alt="">
          <img v-if="props.row.satisfacao == 10" width="20px" src="https://i.im.ge/2023/03/31/ID7dOx.50000006.png" alt="">

        </b-table-column>
        <b-table-column  field="acoes">
        </b-table-column>


        <!-- <b-table-column>
          <div class="flex text-sm items-center">
            <a href="#" class="mr-4 bg-primary-600 rounded-full p-2">
              <Icon-Eye class="text-neutral-100" size="4"/>
            </a>
            <a href="#" class="bg-error-base rounded-full p-2" @click.prevent="deleteInvitee(props.row)">
              <Icon-Trash class="text-neutral-100" size="4"/>
            </a>
          </div>
        </b-table-column> -->
      </template>
      <template v-slot:empty>
        <NotFoundData text="Nenhum convite encontrado!"/>
      </template>
    </b-table>
    <b-modal
      :active.sync="IndicacaoCadasModal"
      width="800px"
      
      id="modal-tall"
    >
      <div class="bg-neutral-300 p-8">
        <div class="modal-body" >
          <label
        class="flex flex-col pb-4"
      >
          <Lynx-Title text="Indicação" />
          <Lynx-Label label="Cliente que indicou" />
        <b-autocomplete
          :data="filteredClientes"
          placeholder="Pesquise um Cliente"
          field="cliente"
          :loading="isFetching"
          @input="getAsyncCliente"
          @select="(option) => (form.customer_id = option.id)"
        />
      </label>


          <!-- <Lynx-Label label="Nome da Cobrança" /> -->
          <Lynx-Input v-show="false" v-model="form.id" class="w-full my-2" />
          <Lynx-Label label="Nome completo" />
          <Lynx-Input
            placeholder="Insira o nome  do indicado"
            v-model="form.nome"
            class="w-full my-2"
          />
          <Lynx-Label label="email*" />
          <Lynx-Input
            placeholder="Insira o email do indicado"
            v-model="form.email"
            class="w-full my-2"
          />
          <Lynx-Label label="CPF" />
          <Lynx-Input
            placeholder="Insira o CPF do indicado"
            v-model="form.cpf"
            class="w-full my-2"
            mask="###.###.###-##" 
          />
        <Lynx-Label label="Telefone" />
          <Lynx-Input
            placeholder="Insira o telefone do indicado"
            v-model="form.telefone"
            class="w-full my-2"
        mask="(##) #####-####" 

          />
        </div>


        <div class="flex flex-col mt-5">
          <Lynx-Button
            :disabled="lista_campos.status == ''"
            :text="!lista_campos.id ? 'cria' : 'edita'"
            class="mb-8"
            icon="Reload"
            @click.native="confirm(!lista_campos.id ? 'cria' : 'edita')"
            size="small"
            icon-size="3"
          />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { clientesSearchRequest } from "@/services/requests/clientes";

import NotFoundData from "@/components/layouts/NotFoundData";
import {getSatisfacaoRequest} from "@/services/requests/satisfacao";
import { monthNames, dayNames } from '@/utils/utils'
import moment from "moment";
import debounce from "@/mixins/debounce";
import {formatEnToBr} from '@/utils/momentHelpers'

export default {
  name: "Satisfação",
  components: {NotFoundData},
  mixins: [debounce],

  data() {
    return {
      form: {
        nome: "",
        email: "",
        cpf: "",
        telefone: "",
        customer_id:null


      },
         monthNames,
      dayNames,
      moment,
      loading: false,
      satisfacao: [],
      satisfacao_filtro: [],

         form_pes: {
        data_inicio: new Date(new Date()- 1 * 86400000) ,
        data_fim: new Date(),
      
      },
      columns: [
        {
          field: 'id',
          label: 'ID',
          searchable: true,
          sortable: true,
        },
        {
          field: 'cliente.id',
          label: 'id cliente',
          searchable: true,
          sortable: true,
        },
        {
          field: 'cliente.nome_completo',
          label: 'cliente',
          searchable: true,
          sortable: true,
        },
        {
          field: 'created_at',
          label: 'data',
        
        },
        {
          field: 'status',
          label: 'status',
       
        },
        {
          field: 'acoes',
          label: 'Ações',
        },
      ],

      IndicacaoCadasModal: false,
      lista_campos: {},
      isFetching: false,
      clientes: [],

    }
  },
  mounted() {
    this.fetchSatisfacao()
  },
  filters: {
    formatEnToBr,
    customerTreatment(value) {
      let name = ''
      if (value.customer && value.customer.empresa) {
        name += value.customer.empresa.map(a => a.id).join(', ')
        name += ' - ' + value.customer.nome_completo.split(' ')[0]
      } else if (value.customer) {
        name += value.customer.nome_completo.split(' ')[0]
      }
      return name
    }

  },
  computed:{
    mensagem_alert(){
      return this.$store.state.indicacao.mensagem_alert
    },
    filteredClientes() {
      return this.clientes.map((item) => {
        return {
          id: item.id,
          cliente: `${item.id} - ${item.nome_completo}`,
        };
      });
    },
  },
  methods: {
    filtersItems(){
      this.satisfacao_filtro  =      this.satisfacao.filter(item => {
        const itemDate = new Date(item.created_at);
          const startDate = new Date(this.form_pes.data_inicio);
          const endDate = new Date(this.form_pes.data_fim);
      

          
          return itemDate >= startDate && itemDate <= endDate;  }

        ); 
    },
    async confirm(tipo,value) {
      await this.$buefy.dialog.confirm({
        message: `Esta ação  ` + tipo + ` um Tipo de Cobrança no sistema?`,
        confirmText: "Sim",
        cancelText: "Não",
        type: "is-success",
        onConfirm: () => {
          if (tipo == "cria") this.create();
          if (tipo == "edita") this.update();
         
        },
      });
    },
    async create() {
      this.loading = true;
      await this.$store
        .dispatch("indicacao/create_indicacao", this.form)
        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
        })
      
        .finally(() => (this.loading = false));

      this.IndicacaoCadasModal = false;
      this.listar_tipo_cobrancas();

      //   this.fireAlert({
      //     ...this.mensagem_alert,
      //     routeName: "produto",
      //   });
    },
    async update() {
      await this.$store
        .dispatch("indicacao/update_tipo_conbranca", this.form)

        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
        })
        .catch((error) => this.$snack.error(this.mensagem_alert.message))
        .finally(() => (this.loading = false));

      this.TipoCobrancaCadasModal = false;
      this.listar_tipo_cobrancas();
    },
  
    deleteInvitee(item) {
      if (!confirm('Tem certeza que deseja remover este convidado?')) {
        return
      }
      this.loading = true
      deleteInviteRequest(item.id)
        .then(() => this.fetchSatisfacao())
        .catch(error => this.$snack.error(error.response.data.message || 'Erro ao deletar'))
        .finally(() => this.loading = false)
    },
    fetchSatisfacao() {
      this.loading = true
      getSatisfacaoRequest(this.form_pes)
        .then(response => {this.satisfacao = response.data
           this.satisfacao_filtro =response.data })
        .catch(error => this.$snack.error(error.response.data.message))
        .finally(() => this.loading = false)
     
       
     
    },
    exportRelatorio(nome) {
      window.open(
        `${process.env.VUE_APP_API_URL}/satisfacao/` +
          nome +
          `?token=${this.$store.getters.getToken}`,
        "_blank"
      );
    },    cadastrar() {
      this.atualizar("");

      this.IndicacaoCadasModal = true;
    },
    atualizar(value) {
      this.lista_campos = value;
      this.form.id = value.id;

      this.form.nome = value.nome;
      this.form.email = value.email;

      this.form.cpf = value.cpf;
      this.form.telefone = value.telefone;
      this.costumes_id = value.costumes_id;
    },
    getAsyncCliente(name) {
      if (!name) return;
      let self = this;
      this.debounce(function () {
        self.isFetching = true;
        clientesSearchRequest(name)
          .then((response) => {
            self.clientes = response.data.data;
          })
          .catch((error) => self.$snack.error(error.response.data.message))
          .finally(() => (self.isFetching = false));
      }, 600);
    },
  }
}
</script>

<style scoped>

</style>
